export default __webpack_public_path__ + "static/media/face-to-face.19308ec0.svg";